import type { ReactNode } from 'react';

import { useTabs } from '../Tabs';

type TabPanelProps = {
  children:
    | ReactNode
    | ((params: {
        selectTab: (tab: number) => void;
        isActive: boolean;
      }) => ReactNode);
  isActive?: boolean;
};

const TabPanel = ({ isActive = false, children, ...rest }: TabPanelProps) => {
  const panelProps = {
    role: 'tabpanel',
    style: {
      ...(!isActive && { display: 'none' }),
    },
    'aria-hidden': !isActive,
    ...rest,
  };
  const { onSelectTab } = useTabs();

  return (
    <div {...panelProps}>
      {typeof children === 'function'
        ? children({ selectTab: onSelectTab, isActive })
        : children}
    </div>
  );
};

TabPanel.displayName = 'TabPanel';

export { TabPanel };
